/* hej-geen-levering — zet de koopknoppen dicht voor een bezoeker uit een land waar niet
 * geleverd wordt, en meldt dat in een balk.
 *
 * ── Waarom dit niet server-side kan ───────────────────────────────────────────────────
 * De eerste opzet bepaalde dit in Liquid met `localization.country.iso_code`. Dat was fout.
 * Op de kale domeinnaam zit de bezoeker in de markt International, en dat veld geeft daar
 * het standaardland van die markt en niet het land van de bezoeker. Voor iedereen kwam daar
 * "United States" uit. Live misgegaan op 2026-09-17, aangetoond met een schermafbeelding.
 *
 * De enige juiste bron is `browsing_context_suggestions.json`, veld
 * `detected_values.country.handle`. Die geeft NL voor een Nederlandse bezoeker, óók op de
 * kale domeinnaam; gemeten op 2026-09-17.
 *
 * ── Samenwerking met het script in de <head> ──────────────────────────────────────────
 * Dat antwoord komt pas als de pagina al getekend is. Daarom zet een klein inline script in
 * de <head> van layout/theme.liquid het slot al vóór de eerste tekening:
 *
 *   bewuste landkeuze bekend    -> niets, de winkel is open
 *   land al bekend dit bezoek   -> meteen `hej-geen-levering` als we er niet leveren
 *   land nog onbekend           -> `hej-koop-wacht`: klikken doen niets, onzichtbaar
 *
 * Dit bestand maakt het af: vraagt het land op, onthoudt het, haalt het wachtslot weg,
 * zet de knoppen voor hulpmiddelen en toetsenbord dicht, en toont de balk.
 *
 * Tot 2026-09-17 wachtte dit bestand met opvragen tot de hele pagina geladen was, inclusief
 * afbeeldingen. In die tijd waren de knoppen klikbaar; de gebruiker merkte dat "je kunt als
 * je heel snel bent gewoon op de knop klikken". Nu begint het opvragen meteen, en wacht
 * alleen de balk op het laden, voor een vloeiende overgang.
 *
 * De lijst met verkooplanden staat op <html> in `data-hej-verkooplanden`, gezet door dat
 * script in de <head> vanuit de Liquid-lijst `hej_verkooplanden`. Eén bron.
 *
 * De teksten van de balk staan in `snippets/hej-balk-teksten.liquid`.
 */
(function () {
  var WORTEL = document.documentElement;
  var DISMISS_KEY = 'hej_geen_levering_weggeklikt';
  var BALK_KIES = '.lvh-geo-suggest--geen-levering';
  var OPSLAG_LAND = 'hej_land';
  var OPSLAG_KEUZE = 'hej_land_keuze';

  /* Alles wat een product in de winkelwagen zet, de winkelwagen opent of naar het
     afrekenen gaat. De link "Kies een ander land" staat hier bewust NIET in: dat is de
     uitweg voor een bezoeker die verkeerd geplaatst is, bijvoorbeeld via een VPN.

     Dezelfde knoppen staan twee keer als opmaak in assets/hej-geen-levering.css. Komt er
     een koopknop bij, pas dan alle drie de lijsten aan.

     Aangevuld op 2026-09-17 op verzoek van de gebruiker ("ook niet de direct kopen
     knoppen"). Alle koopknoppen van de eigen secties nagelopen en live geteld per
     paginatype: op een laptop-productpagina staan alleen data-hap-buy-btn,
     data-hap-quick-buy en data-hapi-bundle-add, en die ontbraken. Daar deed het slot dus
     niets. */
  var KOOP = [
    '[data-buynow]',
    'button[name="add"]',
    'form[action*="/cart/add"] button[type="submit"]',
    'form[action*="/cart/add"] input[type="submit"]',
    '[name="checkout"]',
    '[data-cart-trigger]',
    'a[href$="/cart"]',
    'a[href*="/checkout"]',
    '[data-pc-direct-buy]',            /* "Direct kopen" in de configurator */
    '[data-pc-submit]',                /* "Ga door" in de configurator */
    '[data-hap-buy-btn]',              /* koopknop productpagina */
    '[data-hap-quick-buy]',            /* snelle koop productpagina */
    '[data-hapi-bundle-add]',          /* bundelkaarten op de productpagina */
    '.product-card__quick-add-button', /* productkaarten van de basistheme */
    /* De snelle betaalknoppen van Shopify (Shop Pay, PayPal, Apple Pay) slaan de
       winkelwagen over en gaan rechtstreeks naar de kassa. */
    '.shopify-payment-button__button',
    'shop-pay-button',
    '[data-shopify="payment-button"]'
  ].join(',');

  /* Formulieren die een product toevoegen zonder dat hun action dat verraadt. De
     configurator post met JavaScript vanuit <form class="pc-form" data-pc-form>. */
  var KOOPFORMULIEREN = 'form[data-pc-form]';

  var verkooplanden = (WORTEL.getAttribute('data-hej-verkooplanden') || '').split(',');

  function lees(opslag, sleutel) {
    try { return window[opslag].getItem(sleutel); } catch (e) { return null; }
  }
  function schrijf(opslag, sleutel, waarde) {
    try { window[opslag].setItem(sleutel, waarde); } catch (e) { /* geblokkeerd */ }
  }
  function leverbaar(landcode) {
    return verkooplanden.indexOf(landcode) !== -1;
  }

  /* ── De twee eindtoestanden ────────────────────────────────────────────────── */

  /* Allebei hier bovenaan en niet bij hun functies: stap 2 hieronder kan zetOpSlot al
     aanroepen voordat de regels verderop in dit bestand zijn uitgevoerd. Een var die pas
     daar een waarde krijgt, zou een al gezette waarde weer terugzetten. */
  var opSlot = false;
  var vangnetAan = false;

  function zetOpen() {
    WORTEL.classList.remove('hej-koop-wacht');
    WORTEL.classList.remove('hej-geen-levering');
    if (!opSlot) return;
    /* Alleen als eerder dit bezoek iets anders was vastgesteld, bijvoorbeeld na het
       aanzetten of uitzetten van een VPN in hetzelfde tabblad. Dan alles terugdraaien. */
    opSlot = false;
    var dicht = document.querySelectorAll('[data-hej-dicht]');
    for (var i = 0; i < dicht.length; i++) {
      dicht[i].removeAttribute('data-hej-dicht');
      dicht[i].removeAttribute('aria-disabled');
      dicht[i].removeAttribute('tabindex');
      if (dicht[i].tagName === 'BUTTON' || dicht[i].tagName === 'INPUT') dicht[i].disabled = false;
    }
  }

  function zetOpSlot() {
    WORTEL.classList.add('hej-geen-levering');
    WORTEL.classList.remove('hej-koop-wacht');
    if (opSlot) return;
    opSlot = true;
    zetAllesDicht();
    houdKlikkenTegen();
  }

  /* ── Beslissen ─────────────────────────────────────────────────────────────── */

  /* 1. Een bewuste keuze op de kies-je-land-pagina wint van het IP-adres. Een Nederlander
        op vakantie in Costa Rica moet naar zijn huisadres kunnen bestellen. */
  var keuze = lees('localStorage', OPSLAG_KEUZE);
  if (keuze && leverbaar(keuze)) {
    zetOpen();
    return;
  }

  /* 2. Al bekend dit bezoek: meteen handelen. Het script in de <head> heeft de klasse al
        gezet; hier komen de toegankelijkheidsattributen en het klikvangnet erbij. Toch nog
        opvragen: voor de landnaam in de balk, en omdat het land veranderd kan zijn. */
  var bekend = lees('sessionStorage', OPSLAG_LAND);
  if (bekend && !leverbaar(bekend)) zetOpSlot();

  /* 3. Opvragen, meteen en niet pas na het laden. */
  if (!window.Shopify || !window.Shopify.routes) {
    if (!bekend) zetOpen();
    return;
  }

  fetch(window.Shopify.routes.root + 'browsing_context_suggestions.json?country[enabled]=true')
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (data) {
      var land = data && data.detected_values && data.detected_values.country;
      /* Geen land te bepalen: open. Liever een open winkel voor iemand die we niet kunnen
         plaatsen dan een dichte winkel voor een echte klant; de kassa is het echte slot. */
      if (!land || !land.handle) {
        if (!bekend) zetOpen();
        return;
      }
      schrijf('sessionStorage', OPSLAG_LAND, land.handle);

      if (leverbaar(land.handle)) {
        zetOpen();
        return;
      }
      zetOpSlot();
      naHetLaden(function () { toonBalk(land.name || land.handle); });
    })
    .catch(function () {
      if (!bekend) zetOpen();
    });

  function naHetLaden(fn) {
    /* De balk wacht wel op het laden: een overgang die start terwijl de hoofdthread nog
       druk is, hakkelt. Het slot hierboven wacht daar bewust niet op. */
    if (document.readyState === 'complete') fn();
    else window.addEventListener('load', fn, { once: true });
  }

  /* ── De balk ───────────────────────────────────────────────────────────────── */

  function toonBalk(shopifynaam) {
    var balk = document.querySelector(BALK_KIES);
    /* Niet op elke pagina: op de kies-je-land-pagina staat hij bewust niet. Het slot
       hierboven geldt daar wel. */
    if (!balk) return;
    if (lees('sessionStorage', DISMISS_KEY)) return;

    /* Staat de landenbalk al in beeld, dan niet er nog een tweede bovenop zetten. In de
       praktijk sluiten de twee elkaar uit, want de landenbalk zwijgt als er geen betere
       markt is; dit is de zekerheid voor het geval dat ooit verandert. */
    var landenbalk = document.querySelector('.lvh-geo-suggest:not(' + BALK_KIES + ')');
    if (landenbalk && landenbalk.classList.contains('is-visible')) return;

    /* De taal van de PAGINA. Deze balk stuurt je nergens naartoe, je blijft hier, dus hoort
       hij in dezelfde taal te staan als alles eromheen. De landnaam komt van Shopify en
       staat daardoor ook in de taal van de pagina. De zin noemt het land vóór een dubbele
       punt, zodat een lidwoord of naamval nooit fout kan staan; zie het snippet. */
    var B = window.hejBalk;
    if (!B) return;
    var taal = B.paginataal;
    balk.querySelector('.lvh-geo-text').textContent = B.vul(B.tekst('nolevering', taal, 'tekst'), {
      '[LAND]': shopifynaam
    });

    var sluitTekst = B.tekst('nolevering', taal, 'sluit');
    balk.querySelector('.lvh-geo-dismiss-text').textContent = sluitTekst;
    balk.querySelector('.lvh-geo-dismiss').setAttribute('aria-label', sluitTekst);
    var altSpan = balk.querySelector('.lvh-geo-alt span');
    if (altSpan) altSpan.textContent = B.tekst('nolevering', taal, 'kies');

    /* Hoogte meten terwijl de balk al in de layout zit maar nog buiten beeld staat, zodat
       de header exact evenveel omlaag kan. Dubbele requestAnimationFrame om dezelfde reden
       als bij de suggestiebalk: één enkele garandeert niet dat de buiten-beeld-staat al
       geschilderd is, en dan springt de balk zonder overgang over de header heen. Die bug
       is op 2026-09-02 met de hand gevonden; niet vereenvoudigen zonder te meten. */
    balk.hidden = false;
    WORTEL.style.setProperty('--hej-geo-bar-h', balk.offsetHeight + 'px');

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        balk.classList.add('is-visible');
        WORTEL.classList.add('hej-has-geo-bar');
      });
    });

    var sluit = balk.querySelector('[data-hej-nolevering-dismiss]');
    if (sluit) {
      sluit.addEventListener('click', function () {
        schrijf('sessionStorage', DISMISS_KEY, '1');
        balk.classList.remove('is-visible');
        WORTEL.classList.remove('hej-has-geo-bar');
        setTimeout(function () { balk.hidden = true; }, 320);
      });
    }

    window.addEventListener('resize', function () {
      if (balk.classList.contains('is-visible')) {
        WORTEL.style.setProperty('--hej-geo-bar-h', balk.offsetHeight + 'px');
      }
    }, { passive: true });
  }

  /* ── Koopknoppen dicht ─────────────────────────────────────────────────────── */

  function zetDicht(el) {
    if (el.getAttribute('data-hej-dicht') === '1') return;
    el.setAttribute('data-hej-dicht', '1');
    el.setAttribute('aria-disabled', 'true');
    /* Niet met de tab-toets te bereiken, anders is het alleen visueel dicht. */
    el.setAttribute('tabindex', '-1');
    if (el.tagName === 'BUTTON' || el.tagName === 'INPUT') el.disabled = true;
  }

  function zetAllesDicht(bereik) {
    var wortel = bereik || document;
    /* Het element zelf kan de knoop zijn die net is bijgeplaatst; querySelectorAll kijkt
       alleen naar kinderen, dus die eerst apart. */
    if (wortel.matches && wortel.matches(KOOP)) zetDicht(wortel);
    var lijst = wortel.querySelectorAll(KOOP);
    for (var i = 0; i < lijst.length; i++) zetDicht(lijst[i]);
  }

  /* Vangnet. De opmaak houdt de muisklik al tegen, maar niet een toets op een knop die
     focus had, en een knop die ná ons wordt bijgeplaatst is nog niet behandeld. Daarom ook
     de klik en het verzenden zelf tegenhouden, in de capture-fase, vóór het script van die
     knop hem ziet. Document-breed omdat het gedrag dat ook is; zie ARCHITECTURE.md over
     echt globaal gedrag. Kijkt steeds naar opSlot, zodat terugdraaien in zetOpen werkt. */
  function blokkeerKlik(e) {
    if (!opSlot) return;
    var doel = e.target.closest && e.target.closest(KOOP);
    if (!doel) return;
    e.preventDefault();
    e.stopPropagation();
  }

  function blokkeerVerzenden(e) {
    if (!opSlot) return;
    var formulier = e.target;
    var actie = (formulier.getAttribute && formulier.getAttribute('action')) || '';
    var koopt = actie.indexOf('/cart/add') !== -1
      || actie.indexOf('/checkout') !== -1
      || (formulier.matches && formulier.matches(KOOPFORMULIEREN));
    if (!koopt) return;
    e.preventDefault();
    e.stopPropagation();
  }

  function houdKlikkenTegen() {
    if (vangnetAan) return;
    vangnetAan = true;
    document.addEventListener('click', blokkeerKlik, true);
    document.addEventListener('submit', blokkeerVerzenden, true);

    /* Knoppen die later bijkomen, bijvoorbeeld na "Toon meer" of bij het openen van de
       winkelwagenlade. Alleen toegevoegde knopen bekijken, geen hele-documentscan. */
    if (window.MutationObserver) {
      new MutationObserver(function (records) {
        if (!opSlot) return;
        for (var i = 0; i < records.length; i++) {
          var nieuw = records[i].addedNodes;
          for (var j = 0; j < nieuw.length; j++) {
            if (nieuw[j].nodeType === 1) zetAllesDicht(nieuw[j]);
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
})();
